// Polyfill for dependencies that reference process in the browser (e.g. chart.js, amcharts)
if (typeof process === 'undefined') {
  window.process = { env: { NODE_ENV: 'development' } };
} else if (!process.env) {
  process.env = { NODE_ENV: 'development' };
}
